import { type CommonProps, ONBOARDING_EVENTS, trackEvent } from "."

export const subjects = {
  selectSubjectTitle: (props: CommonProps) =>
    trackEvent(ONBOARDING_EVENTS.SELECT_SUBJECT_TITLE, props),
}
